export default "__VITE_ASSET__DePGWvAO__"